import React, { SVGProps, useContext } from 'react'
import AppContext from '../../app/context'

const UncheckedIcon = (props: SVGProps<SVGSVGElement>) => {
  const { state } = useContext(AppContext)

  if (!state.locationDesignConfig?.baseColors) return null

  return (
    <svg
      {...props}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="28"
        height="28"
        rx="3"
        fill="white"
        stroke={state.locationDesignConfig.baseColors.primary}
        strokeWidth="2"
      />
    </svg>
  )
}

export default UncheckedIcon
